export const mileStoneStatus = {
  yetToStart: "Yet to start",
  inProgress: "In progress",
  achieved: "Achieved",
  delayed: "Delayed",
  achievedButDelayed: "Achieved but delayed",
  beforeTimeCompletion: "Before time achieved",
};
export const contractsType = {
  PRIME: "PRIME",
  INTERNAL: "INTERNAL",
  WORK_ORDER: "WORK_ORDER",
  PURCHASE_ORDER: "PURCHASE_ORDER",
};
export const contractsTypeDatasource = [
  { name: "Prime", value: contractsType.PRIME },
  { name: "Internal", value: contractsType.INTERNAL },
  { name: "Work Order", value: contractsType.WORK_ORDER },
  { name: "Purchase Order", value: contractsType.PURCHASE_ORDER },
];
export const manageWBSItemSteps = {
  showLinkedItems: "showLinkedItems",
  linkedItemsFromEstimate: "linkedItemsFromEstimate",
  showCDB: "showCDB",
  linkManualItem: "linkManualItem",
  showCostDatabaseItems: "showCostDatabaseItems",
  showParentWBSItems: "showParentWBSItems",
};
export const linkWBSSources = {
  projectWBS: "projectWBS",
  parentContractWBS: "parentContractWBS",
  contractWBS: "contractWBS",
  contractWBSInForm: "contractWBSInForm",
};

/** contracts.type -> display heading. Indexed by `contractDetails.type`, hence the index signature. */
export const contractsTypeHeading: Record<string, string> = {
  PRIME: "Prime",
  INTERNAL: "Internal",
  WORK_ORDER: "Work Order",
  PURCHASE_ORDER: "Purchase Order",
};
